// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__lkMRC","header":"Page_header__ZmNVK","goBack":"Page_goBack__fy+4k","title":"Page_title__AIBEO","pageContent":"Page_pageContent__aPIoa"};